import { Popup } from "devextreme-react/popup";
import ScrollView from "devextreme-react/scroll-view";
import { TreeList, Column, ColumnFixing } from "devextreme-react/tree-list";

export default function WorkOrderPopup({ onClose, selectedData }) {
  const workOrders = selectedData.row.data.workOrders;

  return (
    <>
      <Popup
        visible={true}
        onHiding={onClose}
        hideOnOutsideClick={true}
        title="Work Orders"
        width="80%"
        height="80%"
        resizeEnabled={true}
      >
        <ScrollView height="100%" width="100%">
          <TreeList
            id="treelist"
            dataSource={workOrders}
            showRowLines={true}
            showColumnLines={true}
            showBorders={true}
            columnAutoWidth={true}
            allowColumnResizing={true}
            columnResizingMode="widget"
            columnHidingEnabled={true}
            autoExpandAll={false}
            wordWrapEnabled={true}
            itemsExpr="workorderForLab"
            rowAlternationEnabled={false}
          >
            <ColumnFixing enabled={true} />
            <Column dataField="name" cellRender={cellRender} />
            <Column dataField="startDate" dataType="date" />
            <Column dataField="endDate" dataType="date" />
            <Column dataField="allocatedCellHours" caption="Allocated Hours" />
            <Column dataField="actualCellHours" caption="Actual Hours" />
            <Column
              dataField="workCenter"
              cellRender={cellRenderWO2}
              caption="Work Center Breakdown (Beta2)"
            />
          </TreeList>
        </ScrollView>
      </Popup>
    </>
  );
}

const cellRender = (e) => {
  return (
    <a href={e.data.link} target="_blank" rel="noreferrer">
      {e.displayValue}
    </a>
  );
};
const cellRenderWO2 = (e) => {
  const arr = e.data.workorderForLab;
  let holder = {};
  let holder2 = {};

  arr.forEach((x) => {
    if (holder.hasOwnProperty(x.workCenter)) {
      holder[x.workCenter] = holder[x.workCenter] + x.allocatedCellHours;
    } else {
      holder[x.workCenter] = x.allocatedCellHours;
    }
  });

  arr.forEach((x) => {
    if (holder2.hasOwnProperty(x.workCenter)) {
      holder2[x.workCenter] = holder2[x.workCenter] + x.actualCellHours;
    } else {
      holder2[x.workCenter] = x.actualCellHours;
    }
  });
  let arr2 = [];
  for (const prop in holder && holder2) {
    arr2.push({
      workCenter: prop,
      allocatedCellHours: holder[prop],
      actualCellHours: holder2[prop],
    });
  }
  return (
    <ul>
      {arr2.length > 0 &&
        arr2.map((x) => (
          <li key={x.workCenter}>
            <strong>{`${x.workCenter}`}</strong>
            {`: Allocated=${x.allocatedCellHours}, Actual=${x.actualCellHours}`}
            <a href={e.data.link} target="_blank" rel="noreferrer">
              {e.displayValue}
            </a>
          </li>
        ))}
    </ul>
  );
};

//const cellRenderWO = (e) => {
//    const arr = e.data.workorderForLab;
//    let holder = {};
//    let holder2 = {};

//    arr.forEach((x) => {
//        if (holder.hasOwnProperty(x.workCenter)) {
//            holder[x.workCenter] = holder[x.workCenter] + x.allocatedCellHours;
//        } else {
//            holder[x.workCenter] = x.allocatedCellHours;
//        }
//    })

//    arr.forEach((x) => {
//        if (holder2.hasOwnProperty(x.workCenter)) {
//            holder2[x.workCenter] = holder2[x.workCenter] + x.actualCellHours;
//        } else {
//            holder2[x.workCenter] = x.actualCellHours;
//        }
//    })

//    let arr2 = [];
//    for (const prop in holder && holder2) {
//        arr2.push({ workCenter: prop, allocatedCellHours: holder[prop], actualCellHours: holder2[prop] })
//    }
//    const workCenters = arr2.map((x) => `[${x.workCenter}: Allocated=${x.allocatedCellHours}, Actual=${x.actualCellHours}] `)
//    return workCenters;
//}
